import { StrictMode } from "react";

import { Providers } from "@login/components/Providers/Providers";
import { CAGlobals } from "@login/data/globals/CA";
import { USGlobals } from "@login/data/globals/US";
import type { FlashMessage } from "@login/data/types/FlashMessage.d";
import { Pages } from "@login/scenes/Pages/Pages";
import { LazyHotReloadIndicator } from "@shared/components/LazyHotReloadIndicator/LazyHotReloadIndicator";
import { SmartBannerEvents } from "@shared/components/SmartBannerEvents/SmartBannerEvents";
import type { Flipper } from "@shared/types/flipper";

interface Props {
  currentCountry: string;
  flippers: Flipper[];
  flashMessages: FlashMessage[];
}

const Main = ({ currentCountry, flippers, flashMessages }: Props) => {
  const loadGlobals = () => {
    if (currentCountry === CAGlobals.country) {
      return CAGlobals;
    }

    return USGlobals;
  };

  return (
    <StrictMode>
      <Providers global={loadGlobals()} flashMessages={flashMessages} flippers={flippers}>
        <Pages flippers={flippers} />
        <LazyHotReloadIndicator />
        <SmartBannerEvents />
      </Providers>
    </StrictMode>
  );
};

export { Main };
